export default "__VITE_ASSET__tkVUrUHy__"